import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage';
  data: any;
}

export function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
}

export const organizationSchema = {
  name: '레알타드',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  logo: typeof window !== 'undefined' ? `${window.location.origin}/vite.svg` : '',
  description: '메이저 배팅 사이트를 위한 맞춤형 솔루션. 풀 오토 스포츠 배팅, 온라인 카지노, 슬롯, 미니게임, 풀 오토 가상계좌 시스템 등 온라인 갬블링 사업에 필요한 모든 것이 개발되어 있습니다.',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: '고객 지원',
    availableLanguage: ['Korean'],
  },
};

export const websiteSchema = {
  url: typeof window !== 'undefined' ? window.location.origin : '',
  name: '레알타드',
  description: '메이저 배팅 사이트를 위한 맞춤형 솔루션',
  publisher: {
    '@type': 'Organization',
    name: '레알타드',
  },
};

export const webPageSchema = {
  name: '레알타드 - 메이저 사이트를 위한 맞춤형 솔루션',
  description: '메이저 배팅 사이트를 위한 맞춤형 솔루션. 풀 오토 스포츠 배팅, 온라인 카지노, 슬롯, 미니게임, 풀 오토 가상계좌 시스템 등 온라인 갬블링 사업에 필요한 모든 것이 개발되어 있습니다.',
  url: typeof window !== 'undefined' ? window.location.href : '',
};

export const faqSchema = {
  mainEntity: [
    {
      '@type': 'Question',
      name: '레알타드 솔루션은 어떤 서비스를 제공하나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '레알타드는 스포츠 배팅, 온라인 카지노, 슬롯, 포커, 미니게임 등 다양한 갬블링 솔루션을 제공합니다. 모든 시스템은 풀 오토로 운영되며, 가상계좌 시스템도 포함되어 있습니다.',
      },
    },
    {
      '@type': 'Question',
      name: '솔루션 도입 기간은 얼마나 걸리나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '기본 설정은 24시간 이내에 완료되며, 맞춤형 커스터마이징은 프로젝트 규모에 따라 1-2주 정도 소요됩니다.',
      },
    },
    {
      '@type': 'Question',
      name: '기술 지원은 어떻게 받을 수 있나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '텔레그램(@realtad_cs)을 통해 24시간 기술 지원을 받으실 수 있습니다. 전담 팀이 신속하게 대응해드립니다.',
      },
    },
    {
      '@type': 'Question',
      name: '보안은 어떻게 보장되나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '최신 암호화 기술과 다층 보안 시스템을 적용하여 데이터와 거래의 안전을 보장합니다. 정기적인 보안 업데이트와 모니터링을 제공합니다.',
      },
    },
    {
      '@type': 'Question',
      name: '비용은 어떻게 되나요?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '프로젝트 규모와 필요한 기능에 따라 맞춤형 견적을 제공합니다. 텔레그램으로 문의하시면 상세한 상담을 받으실 수 있습니다.',
      },
    },
  ],
};
